import { isNumeric } from '@cutwise/utils';

import { assignModel } from '@/common/helpers/assignModel';
import priceFormatter from '@/common/helpers/priceFormatter';
import { ProductId } from '@/product/entity/Product';

export class FCRFGradeModel {
  productId!: ProductId;
  innerGrade?: Nullable<string>;
  dispersion?: Nullable<string>;
  undertone?: Nullable<string>;
  price?: Nullable<string>;
  priceHigh?: Nullable<string>;
  priceHigh5p?: Nullable<string>;
  priceLow?: Nullable<string>;
  priceLow5p?: Nullable<string>;
  error?: Nullable<string>;
}

export type FCRFSubgradesModel = Pick<FCRFGradeModel, 'innerGrade' | 'dispersion' | 'undertone'>;

export class FCRFGrade extends FCRFGradeModel {
  constructor(model: FCRFGradeModel) {
    super();

    assignModel<FCRFGradeModel>(this, model);
  }

  get formattedPrice() {
    if (!this.lowPrice || !this.highPrice) {
      return null;
    }

    return `${this.lowPrice} — ${this.highPrice}/ct`;
  }

  get averagePrice() {
    return this.formatPrice(this.price);
  }

  get rangePrice() {
    if (!this.lowPrice || !this.highPrice) {
      return null;
    }

    return `${this.lowPrice} - ${this.highPrice}`;
  }

  get rangePricePerCt() {
    if (!this.rangePrice) {
      return null;
    }

    return `${this.rangePrice}/ct`;
  }

  get lowPrice() {
    return this.formatPrice(this.priceLow);
  }

  get highPrice() {
    return this.formatPrice(this.priceHigh);
  }

  get lowPrice5p() {
    return this.formatPrice(this.priceLow5p);
  }

  get highPrice5p() {
    return this.formatPrice(this.priceHigh5p);
  }

  private formatPrice(price?: Nullable<string>) {
    if (!isNumeric(price)) {
      return null;
    }

    return priceFormatter.format(+price);
  }
}
